import { Grid2, IconButton, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";

import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import MaterialSelect from "../components/MasterSelect";
import { IoClose } from "react-icons/io5";
import MaterialTypography from "../components/MaterialTypography";
import MaterialBox from "../components/MaterialBox";

const ReusableFilter = ({
  filterparam,
  setfilterdata,
  openfilter,
  handleclosefilter,
  unfiltereddata,
}) => {
  console.log(unfiltereddata, "unfill");

  const maximumfilter_size = 3;
  const filtersize =
    12 / (filterparam?.length || 1) < maximumfilter_size
      ? maximumfilter_size
      : 12 / (filterparam?.length || 1);

  const [filtervalues, setfiltervalues] = useState({});
  console.log(filtervalues, "filvaluess");

  const convertunfiltereddata_to_filtered = (field, value) => {
    setfiltervalues((prev) => ({
      ...prev,
      [field]: value,
    }));
    console.log(unfiltereddata, "3Fillbefore");

    const filtered = unfiltereddata?.filter(
      (unfiltered) => unfiltered[value?.field] === value?.value
    );
    console.log(filtered, "3Fillafter");
    setfilterdata(filtered);
  };

  const handleclose = () => {
    handleclosefilter();
    setfiltervalues({});
  };

  return (
    <Dialog
      open={openfilter}
      keepMounted
      onClose={handleclose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 9, sm: 9 }}>
            <MaterialTypography variant="h6" color="black" fontWeight="bold">
              Filter
            </MaterialTypography>
          </Grid2>
          <Grid2 size={{ xs: 3, sm: 3 }}>
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              onClick={handleclose}
              sx={{ cursor: "pointer" }}
            >
              <IoClose />
            </MaterialBox>
          </Grid2>
        </Grid2>
      </DialogTitle>
      <DialogContent>
        {
          <Grid2 container spacing={1} size={{ xs: 12, md: 12, lg: 12 }}>
            {filterparam?.map((param, index) => (
              <Grid2 size={{ xs: 12, md: 6, lg: filtersize }}>
                <Typography variant="overline" color="black" fontWeight="bold">
                  {param?.field}
                </Typography>
                <MaterialSelect
                  value={filtervalues[index] || ""}
                  onChange={(e) => convertunfiltereddata_to_filtered(index, e)}
                  options={param?.options}
                />
              </Grid2>
            ))}
          </Grid2>
        }
      </DialogContent>
    </Dialog>
  );
};
export default ReusableFilter;
